var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSettingsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1205,
    height: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1457,
    y: -4,
    width: 1205,
    height: 1200
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1457 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1476 597.5C1476 274.69 1737.69 13.0001 2060.5 13.0001 2383.31 13.0001 2645 274.69 2645 597.5 2645 920.311 2383.31 1182 2060.5 1182 1737.69 1182 1476 920.311 1476 597.5Z",
    stroke: "#D9D9D9",
    strokeWidth: 27.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.5 264.5C1774.5 237.99 1795.99 216.5 1822.5 216.5L1822.5 216.5C1849.01 216.5 1870.5 237.99 1870.5 264.5L1870.5 934.5C1870.5 961.01 1849.01 982.5 1822.5 982.5 1795.99 982.5 1774.5 961.01 1774.5 934.5Z",
    stroke: "#404040",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736.5 424.5C1736.5 376.451 1775.45 337.5 1823.5 337.5 1871.55 337.5 1910.5 376.451 1910.5 424.5 1910.5 472.549 1871.55 511.5 1823.5 511.5 1775.45 511.5 1736.5 472.549 1736.5 424.5Z",
    stroke: "#404040",
    strokeWidth: 41.25,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2289.5 264.5C2289.5 237.99 2310.99 216.5 2337.5 216.5L2337.5 216.5C2364.01 216.5 2385.5 237.99 2385.5 264.5L2385.5 934.5C2385.5 961.01 2364.01 982.5 2337.5 982.5 2310.99 982.5 2289.5 961.01 2289.5 934.5Z",
    stroke: "#404040",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250.5 424.5C2250.5 376.451 2289.45 337.5 2337.5 337.5 2385.55 337.5 2424.5 376.451 2424.5 424.5 2424.5 472.549 2385.55 511.5 2337.5 511.5 2289.45 511.5 2250.5 472.549 2250.5 424.5Z",
    stroke: "#404040",
    strokeWidth: 41.25,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2128.5 934.5C2128.5 961.01 2107.01 982.5 2080.5 982.5L2080.5 982.5C2053.99 982.5 2032.5 961.01 2032.5 934.5L2032.5 264.5C2032.5 237.99 2053.99 216.5 2080.5 216.5 2107.01 216.5 2128.5 237.99 2128.5 264.5Z",
    stroke: "#404040",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2166.5 775C2166.5 822.773 2127.55 861.5 2079.5 861.5 2031.45 861.5 1992.5 822.773 1992.5 775 1992.5 727.227 2031.45 688.5 2079.5 688.5 2127.55 688.5 2166.5 727.227 2166.5 775Z",
    stroke: "#404040",
    strokeWidth: 41.25,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSettingsInactive);
export default __webpack_public_path__ + "static/media/map-settings-inactive.1b20e2d4a5da7eb9e3f2185f44031c92.svg";
export { ForwardRef as ReactComponent };